(() => {
  if (window.monumentServicePagesReady) return;
  window.monumentServicePagesReady = true;
  const openers = new WeakMap();
  let savedOverflow = '';
  const close = dialog => dialog?.close();
  const prepare = () => document.querySelectorAll('.msp-dialog').forEach(dialog => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('.msp-dialog[open]')) document.body.style.overflow = savedOverflow;
      openers.get(dialog)?.focus();
    });
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close(dialog);
    });
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-msp-open]');
    if (trigger) {
      const key = trigger.getAttribute('data-msp-open');
      const dialog = Array.from(document.querySelectorAll('.msp-dialog')).find(el => el.dataset.mspDialog === key);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      prepare();
      if (dialog.open) return;
      savedOverflow = document.body.style.overflow;
      openers.set(dialog, trigger);
      const iframe = dialog.querySelector('iframe[data-src]');
      if (iframe && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.dataset.src);
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-msp-close]')?.focus();
    }
    const closeButton = event.target.closest('[data-msp-close]');
    if (closeButton) close(closeButton.closest('dialog'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, {once:true});
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.msp-dialog[open]').forEach(close);
  });
})();
